export default __webpack_public_path__ + "static/media/japan.829512dc.PNG";